
import React, { useEffect, useState } from 'react';
import RegistrationForm from '@/components/RegistrationForm';
import { motion } from 'framer-motion';
import { useIsMobile } from '@/hooks/use-mobile';
import { Header, InfoAlert, ScrollToTopButton, Footer } from '@/components/index-page';

const Index = () => {
  const isMobile = useIsMobile();
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Effect to set page title and scroll to top on mount
  useEffect(() => {
    document.title = "Họp mặt Cựu học sinh Lê Hồng Phong";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 via-sky-50 to-white">
      <Header />
      
      <main className="container mx-auto pt-6 md:pt-8 pb-4 md:pb-6 px-3 md:px-4 max-w-5xl">
        <InfoAlert />

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="mx-auto"
          id="registration-form"
        >
          <RegistrationForm />
        </motion.div>
      </main>
      
      <ScrollToTopButton visible={showScrollButton} />
      <Footer />
    </div>
  );
};

export default Index;
